// SPDX-License-Identifier: AGPL-3.0-or-later
import {makeSyncedField} from '@app/features/user/state/SyncedField';
import {InputMonitoringPromptsStateSchema} from '@app/vendor/schema/gen/fluxer/user/preferences/v1/preferences_pb';
import {makeAutoObservable} from 'mobx';

class InputMonitoringPrompts {
	hasSeenInputMonitoringCTA = false;
	private shownThisSession = false;
	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
		void this.initPersistence();
	}
	private async initPersistence(): Promise<void> {
		await makeSyncedField(this, {
			field: 'inputMonitoring',
			schema: InputMonitoringPromptsStateSchema,
			persist: ['hasSeenInputMonitoringCTA'],
			toMessage: (s) => ({seenCta: s.hasSeenInputMonitoringCTA}),
			applyMessage: (s, m) => {
				s.hasSeenInputMonitoringCTA = m.seenCta;
			},
		});
	}
	shouldShowInputMonitoringCTA(): boolean {
		return !this.hasSeenInputMonitoringCTA && !this.shownThisSession;
	}
	markShownThisSession(): void {
		this.shownThisSession = true;
	}
	dismissInputMonitoringCTA(): void {
		this.hasSeenInputMonitoringCTA = true;
		this.shownThisSession = true;
	}
	resetInputMonitoringCTA(): void {
		this.hasSeenInputMonitoringCTA = false;
		this.shownThisSession = false;
	}
}
export default new InputMonitoringPrompts();
